// Copyright (c) 2017 Deere & Company

import MachineStatusUpdates, {getDefaultState} from '../state/machine-status-updates';
import actions from '../../actions-list';

const resetMachineStatusUpdates = () => getDefaultState();

const updateMachineStatusUpdates = (state, action) =>
    MachineStatusUpdates.update(state, {
        $set: action.data
    });

const updateMachineStatusUpdatesList = (state, action) => {

    const index = state.findIndex(item => item.id === action.id);

    return MachineStatusUpdates.update(state, {
        $splice: [
            [
                index,
                1
            ]
        ]
    });

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_TCSM_MACHINE_STATUS_UPDATES]: resetMachineStatusUpdates,
        [actions.UPDATE_PRODUCT_MACHINE_STATUS_UPDATES]: updateMachineStatusUpdates,
        [actions.UPDATE_TCSM_MACHINE_STATUS_UPDATES_LIST]: updateMachineStatusUpdatesList
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/machine-status-update/reducers/machine-status-updates.js